import { useCallback, useState } from 'react'
import { useMediaQuery } from 'react-responsive'
import { Mobile } from '../../../components/media'
import Modal from '../../../components/modal'
import DealershipInformation from '../views/dealership-information'

export default function UpdateDealershipDetails({ onDetailsChange, onClose }) {
  const isMobile = useMediaQuery({ query: '(max-width: 1024px)' })

  const handleDealershipInformationChangeSuccess = useCallback(
    (data, variables) => {
      onDetailsChange((prev) => ({
        ...prev,
        ...variables,
      }))
    },
    [onDetailsChange],
  )

  return (
    <Modal onClose={onClose} hideCloseBtn={isMobile}>
      <Mobile>
        <button className='flatBtn backToAccount' onClick={onClose}>
          &#60; Back to Account
        </button>
      </Mobile>

      <DealershipInformation
        onClose={onClose}
        onSuccess={handleDealershipInformationChangeSuccess}
      />

      <style jsx>{`
        .backToAccount {
          margin: 1rem 0 0 1.3rem;
          color: #a5a8b9;
          line-height: 1.6rem;
          font-size: 1.2rem;
          font-weight: bold;
        }
      `}</style>
    </Modal>
  )
}
